export const configuration = {
    serverBaseUrl: "https://stagingsl.fawkesengineering.com/",
    clientBaseUrl: "https://stagingsl.fawkesengineering.com/"
};